export class SmeltingProductionResult {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',          
          shiftStartTime='',
          shiftEndTime='',         
          productionName= ``,
          planQuantity= ``,
          realQuantity= ``,
          completeRate= ``,
          planOperationRate= ``,
          realOperationRate= ``
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift;
      this.shiftStartTime = shiftStartTime,
      this.shiftEndTime = shiftEndTime,  
      this.productionName = productionName;
      this.planQuantity = planQuantity;
      this.realQuantity = realQuantity;
      this.completeRate = completeRate;
      this.planOperationRate = planOperationRate;
      this.realOperationRate = realOperationRate;
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },        
        {
          key: 'shiftStartTime',
          label: 'lbl.basic.startTime',
          sortable: false,
          form: {
            type: 'displayTime'
          }
        },
        {
          key: 'shiftEndTime',
          label: 'lbl.basic.endTime',
          sortable: false,
          form: {
            type: 'displayTime'
          }
        },                
        {
          key: 'productionName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'planQuantity',
          label: 'lbl.prd.execution.planQuantity',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'realQuantity',
          label: 'lbl.prd.execution.actualQuantity',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'completeRate',
          label: 'lbl.prd.execution.completeRate',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'planOperationRate',
          label: 'lbl.prd.execution.planOperationRate',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'realOperationRate',
          label: 'lbl.prd.execution.realOperationRate',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operate',
          label: 'lbl.basic.update',
          form: {
              type: 'formatter'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingProductionResult()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
    'filter.furnaceNameFilter',   
  ];
  export const filter = {
    'planCodeFilter': "",    
    'startDayFilter': "",
    'endDayFilter': "",
    'plantFilter': "",
    'shiftFilter': "",
    'furnaceNameFilter': "",
  };